<form (ngSubmit)="submit()" [formGroup]="loginForm" action="" class="form">
  <app-input [control]="loginForm.get('email')" label="E-mail"></app-input>
  <app-input [control]="loginForm.get('password')" label="Senha" type="password"></app-input>

  <app-button [enabled]="loginForm.valid" customStyle="login" text="Login" type="submit"></app-button>
</form>
